if (!customElements.get("td-combined-listing")) {
  let pendingRequests = new Map();
  let prefetchRequests = new Set();
  let prefetchCache = new Map();
  let ongoingFetches = new Set();
  
  class TdCombinedListing extends HTMLElement {
    constructor() {
      super();
      this.products = this.querySelectorAll('[data-product-handle]');
      this.stickyProducts = document.querySelectorAll('[data-sticky-product-handle]');
      this.stickySelectElement = document.querySelector('[data-combined-listing-select]');
      this.isDataSavingMode = navigator?.connection?.saveData
      this.fetchSectionsTimeout = null;
      this.prefetchSectionsTimeout = null;
      this.sections = document.querySelectorAll('[data-combined-listing]')
      this.combinedProductFormId = document.querySelector('[data-combined-product-form-id]')?.getAttribute('data-combined-product-form-id') || null;
      this.ICON_LIST_ITEM_SELECTOR = "[data-th-shipping-estimate]";
      this.currentSellingPlanId = null;
    }

    connectedCallback() {
      this.currentSellingPlanId = null;
      this.attachProductEvents(this.products, false);
      this.attachProductEvents(this.stickyProducts, true);
      this.addIconListShippingText();
      this.initRadioOptions();
      this.centerSwiperIfEdgeSelected();
    }

    centerSwiperIfEdgeSelected() {
      setTimeout(() => {
        const swiperEl = document.querySelector('.swiper');
        if (swiperEl && swiperEl.swiper) {
          const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
          const currentIndex = slides.findIndex(slide =>
            slide.querySelector('.td-combined-listing__product')?.classList.contains('td-combined-listing__product--current')
          );
          if (currentIndex === 0 || currentIndex === slides.length - 1) {
            swiperEl.swiper.slideTo(currentIndex, 300); // 300ms animation
          }
        }
      }, 100);
    }

    setRadioButtonState(option, isActive) {
      const checkedRadio = option.querySelector('.td-pps__radio-checked');
      const uncheckedRadio = option.querySelector('.td-pps__radio-unchecked');
      
      if (isActive) {
        option.classList.add('td-pps__radio-option--active');
        option.classList.remove('td-pps__radio-option--inactive');
        if (checkedRadio) checkedRadio.style.display = '';
        if (uncheckedRadio) uncheckedRadio.style.display = 'none';
      } else {
        option.classList.remove('td-pps__radio-option--active');
        option.classList.add('td-pps__radio-option--inactive');
        if (checkedRadio) checkedRadio.style.display = 'none';
        if (uncheckedRadio) uncheckedRadio.style.display = '';
      }
    }
    
    handleOptionSelection(option, updateUrl = true) {
      const optionType = option.getAttribute('data-option-type');
      const isSubscription = optionType === 'subscription';
      
      // Get current URL info if needed for URL updates
      let productHandle, variantId;
      if (updateUrl) {
        const currentUrl = new URL(window.location.href);
        const pathParts = currentUrl.pathname.split('/');
        productHandle = pathParts[pathParts.indexOf('products') + 1];
        variantId = currentUrl.searchParams.get('variant');
      }
      
      // Handle free gift visibility
      const freeGiftElement = document.querySelector('.td-pps__free-gift');
      if (freeGiftElement) {
        if (isSubscription) {
          freeGiftElement.style.display = ''; 
        } else {
          freeGiftElement.style.display = 'none'; 
        }
      }
      
      if (isSubscription) {
        // Handle subscription option
        const activeProduct = document.querySelector('.td-pps-item.td-active');
        if (activeProduct) {
          const container = activeProduct.closest('.td-pps-item-container');
          if (container) {
            const sellingPlanId = container.getAttribute('data-selling-plan-id');
            const productVariantId = container.getAttribute('data-variant-id');
            
            this.currentSellingPlanId = sellingPlanId;
            this.updateSellingPlanInput(sellingPlanId);
            
            // Explicitly set the product variant ID in the form
            const sectionId = this.getAttribute('data-section-id');
            if (sectionId) {
              const sectionElement = document.querySelector(`.${sectionId}`);
              if (sectionElement) {
                const atcButton = sectionElement.querySelector('#AddToCart');
                if (atcButton && atcButton.form) {
                  let idInput = atcButton.form.querySelector('input[name="id"]');
                  if (!idInput) {
                    idInput = document.createElement('input');
                    idInput.setAttribute('type', 'hidden');
                    idInput.setAttribute('name', 'id');
                    atcButton.form.appendChild(idInput);
                  }
                  idInput.value = productVariantId;
                }
              }
            }
            
            const subscriptionPrice = container.getAttribute('data-subscription-original-price');
            this.updatePriceDisplay(subscriptionPrice);

            if (updateUrl) {
              this.updateUrl(productHandle, variantId, sellingPlanId);
            }
          }
        }
        
      } else {
        // Handle one-time option
        this.currentSellingPlanId = null;
        this.updateSellingPlanInput('');
        
        const onetimeProductId = this.getAttribute('data-onetime-product');
        if (onetimeProductId && onetimeProductId.trim() !== '') {
          const sectionId = this.getAttribute('data-section-id');
          if (sectionId) {
            const sectionElement = document.querySelector(`.${sectionId}`);
            if (sectionElement) {
              const atcButton = sectionElement.querySelector('#AddToCart');
              if (atcButton && atcButton.form) {
                let idInput = atcButton.form.querySelector('input[name="id"]');
                if (!idInput) {
                  idInput = document.createElement('input');
                  idInput.setAttribute('type', 'hidden');
                  idInput.setAttribute('name', 'id');
                  atcButton.form.appendChild(idInput);
                }
                idInput.value = onetimeProductId;
              }
            }
          }
        }
        
        if (updateUrl) {
          this.updateUrl(productHandle, variantId, null);
        }
        
        // Update price display
        const regularPrice = option.querySelector('.td-pps__regular-price');
        if (regularPrice) {
          this.updatePriceDisplay(regularPrice.textContent);
        }
      }
    }
    
    initRadioOptions() {
      const radioOptions = document.querySelectorAll('.td-pps__radio-option');
      
      if (!radioOptions.length) return;
      
      // Set initial state based on active option
      const activeOption = document.querySelector('.td-pps__radio-option--active');
      if (activeOption) {
        this.handleOptionSelection(activeOption, false);
      }
      
      // Add click event listeners
      radioOptions.forEach(option => {
        option.addEventListener('click', () => {
          // Reset all radio buttons
          radioOptions.forEach(opt => this.setRadioButtonState(opt, false));
          
          // Set active state for clicked option
          this.setRadioButtonState(option, true);
          
          // Handle the option selection
          this.handleOptionSelection(option, true);
        });
      });
    }



    attachProductEvents(products, isSticky) {
      if (products) {

        products.forEach((prod) => {
          if (!isSticky) {
            prod.addEventListener("mouseover", () => {
              this.handleProductHover(prod);
            });


            prod.addEventListener("click", () => {
              this.handleProductClick(prod);
            });
          } else {        
            if (this.stickySelectElement) {
              this.stickySelectElement.addEventListener("change", (event) => {
                const selectedOption = event.target.selectedOptions[0];
                
                prod.dataset.productHandle = selectedOption.dataset.stickyProductHandle;
                prod.dataset.variantId = selectedOption.dataset.variantId;
                prod.dataset.sellingPlanId = selectedOption.dataset.sellingPlanId || null;
              
                if (selectedOption.dataset.stickyProductHandle && selectedOption.dataset.variantId) {
                  this.handleProductClick(prod);
                }
              });
            }
          }
        });
    
        window.addEventListener("popstate", () => {
          if (history.state && history.state.url === location.href) {
            location.reload();
          }
        });
      }
    }
    
    handleProductHover(prod) {
      const productHandle = prod.dataset.productHandle;
      const variantId = prod.dataset.variantId;
      // Use the currentSellingPlanId if no selling plan ID is provided
      const sellingPlanId = prod.dataset.sellingPlanId || this.currentSellingPlanId;
    
      this.sections.forEach((section) => {
        const section_id = section.dataset.sectionId;
        this.prefetchSection(section_id, `/products/${productHandle}`, variantId, sellingPlanId);
      });
    }
    
    handleProductClick(prod) {
      const productHandle = prod.dataset.productHandle;
      const variantId = prod.dataset.variantId;
      // Use the currentSellingPlanId if no selling plan ID is provided
      const sellingPlanId = prod.dataset.sellingPlanId || this.currentSellingPlanId;
      
      // Save the current URL before updating
      const currentUrl = window.location.href;
      
      // Update sections without changing URL yet
      const sectionPromises = [];
      
      this.sections.forEach((section) => {
        const section_id = section.dataset.sectionId;
        const promise = this.loadSection(section_id, `/products/${productHandle}`, variantId, sellingPlanId).then((content) => {
          const sectionElement = document.querySelector(`[data-section-id='${section_id}']`);
          
          // Save Buy With Prime widget if it exists in this section
          const bwpWrapper = sectionElement.querySelector('.buy-with-prime__wrapper');
          let savedBwpWrapper = null;
          if (bwpWrapper) {
            savedBwpWrapper = bwpWrapper.cloneNode(true);
          }
          
          // Update section content
          sectionElement.innerHTML = this.getSectionInnerHTML(content, `[data-section-id='${section_id}']`);

          // Re-initialize Smartrr widget if present
          if (window.smartrrProductList && window.initSmartrr) {
            // Find the new smartrr block
            const newSmartrr = sectionElement.querySelector('[id*="__smartrr_app_block_"]')
            if (newSmartrr) {
              const scripts = newSmartrr.querySelectorAll('script');
              if (scripts.length > 0) {

                // The script is in the last scrip of the block
                const lastScript = scripts[scripts.length - 1];
                const scriptFunction = new Function(lastScript.textContent);
                // Clear the exiting widgets out of the object
                window.smartrrProductList = {};
                // Run the script from the block
                scriptFunction();
                Object.keys(window.smartrrProductList).forEach(function(uniqueId) {
                  window.initSmartrr(uniqueId);
                  document.dispatchEvent(new Event('DOMContentLoaded'));
                  // A new smartrr widget has been initialized, so we need to remove the extra inputs
                  const smartrrInputs = document.querySelectorAll('[data-smartrr-widget-selling-plan-input]');
                  smartrrInputs.forEach((input,index) => {
                    if (index > 0) {
                      input.remove()
                    }
                  });
                });
              }
            }
          }
          
          // If we saved a Buy With Prime widget, find where to reinsert it
          if (savedBwpWrapper) {
            // Find the new Buy With Prime wrapper location
            const newBwpWrapper = sectionElement.querySelector('.buy-with-prime__wrapper');
            if (newBwpWrapper) {
              // Replace the new wrapper with our saved one
              newBwpWrapper.parentNode.replaceChild(savedBwpWrapper, newBwpWrapper);
            }
          }
          
          sectionElement.dispatchEvent(new CustomEvent("section-content::changed", { bubbles: true, detail: section_id }));
          this.updateSellingPlanInput(sellingPlanId);
        });
        sectionPromises.push(promise);
      });
      
      // Swiper slide centering logic
      this.centerSwiperIfEdgeSelected();
      
      // After all sections are loaded, update URL
      Promise.all(sectionPromises).then(() => {
        // Only update URL if it's different from the current one
        // This prevents unnecessary history.pushState calls that trigger the BWP widget update
        const newUrl = this.buildProductUrl(productHandle, variantId, sellingPlanId);
        if (newUrl !== currentUrl) {
          this.updateUrl(productHandle, variantId, sellingPlanId);
        }
      });
    }
    
    buildProductUrl(productHandle, variantId, sellingPlanId) {
      let newUrl = `/products/${productHandle}`;
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);
    
      // Create a new params object
      const newParams = new URLSearchParams();
      
      // Copy all params except variant and selling_plan
      currentParams.forEach((value, key) => {
        if (key !== "variant" && key !== "selling_plan") {
          newParams.set(key, value);
        }
      });
    
      if (variantId) {
        newParams.set("variant", variantId);
      }
    
      if (sellingPlanId) {
        newParams.set("selling_plan", sellingPlanId);
      }
    
      const paramsString = newParams.toString();
      return `${currentUrl.origin}${newUrl}${paramsString ? '?' + paramsString : ''}`;
    }
    


    buildCacheKey(sectionId, path, variantId) {
      return `${path}:${sectionId}${variantId ? `:variant:${variantId}` : ''}`;
    }
    
    buildRequestGroups(sectionKeys) {
      const groups = sectionKeys.reduce(
        (acc, key) => {
          const [path, sectionId, , variantId] = key.split(':')
          const groupKey = `${path || ''}:${variantId || ''}`
    
          if (!acc[groupKey]) {
            acc[groupKey] = {
              path,
              variantId,
              keys: [],
              sectionIds: [],
            }
          }
          acc[groupKey].keys.push(key)
          acc[groupKey].sectionIds.push(sectionId)
          return acc
        },
        {}
      )
    
      return Object.values(groups)
    }
    
    scheduleFetchSections() {
      if (this.fetchSectionsTimeout) {
        clearTimeout(this.fetchSectionsTimeout)
      }
      this.fetchSectionsTimeout = setTimeout(() => this.fetchSections(), 100)
    }
    
    schedulePrefetchSections() {
      if (this.prefetchSectionsTimeout) {
        clearTimeout(this.prefetchSectionsTimeout)
      }
      this.prefetchSectionsTimeout = setTimeout(() => this.prefetchSections(), 200)
    }
    
    async fetchSections() {
      if (pendingRequests.size === 0) {
        return
      }
    
      const sectionKeys = Array.from(pendingRequests.keys())
      const requestGroups = this.buildRequestGroups(sectionKeys)
    
      try {
        await Promise.all(
          requestGroups.map(async ({ path, variantId, keys, sectionIds }) => {
            const url = new URL(window.location.href)
            if (path) {
              url.pathname = path
            }
            url.searchParams.set('sections', sectionIds.join(','))
            if (variantId) {
              url.searchParams.set('variant', variantId)
            }
            const requestUrl = url.toString()
    
            const response = await fetch(requestUrl)
            if (!response.ok) {
              throw new Error(`Failed to fetch: ${requestUrl}`)
            }
            const sectionsData = await response.json()
    
            keys.forEach((key, index) => {
              const callbacks = pendingRequests.get(key) || []
              pendingRequests.delete(key)
              const sectionId = sectionIds[index]
              const data = sectionsData[sectionId]
              if (data === undefined) {
                callbacks.forEach(({ reject }) => reject(new Error(`No data for section ${sectionId}`)))
              } else {
                callbacks.forEach(({ resolve }) => resolve(data))
                prefetchCache.set(key, data)
              }
              ongoingFetches.delete(key)
            })
          }),
        )
      } catch (error) {
        console.error(error)
        const sectionKeys = Array.from(pendingRequests.keys())
        sectionKeys.forEach((key) => {
          const callbacks = pendingRequests.get(key) || []
          pendingRequests.delete(key)
          callbacks.forEach(({ reject }) => reject(error))
          ongoingFetches.delete(key)
        })
      }
    }
    
    async prefetchSections() {
      if (prefetchRequests.size === 0) {
        return
      }
    
      const sectionKeys = Array.from(prefetchRequests)
      const requestGroups = this.buildRequestGroups(sectionKeys)
    
      try {
        await Promise.all(
          requestGroups.map(async ({ path, variantId, keys, sectionIds }) => {
            const url = new URL(window.location.href)
            if (path) {
              url.pathname = path
            }
            url.searchParams.set('sections', sectionIds.join(','))
            if (variantId) {
              url.searchParams.set('variant', variantId)
            }
            const requestUrl = url.toString()
    
            const response = await fetch(requestUrl)
            if (!response.ok) {
              throw new Error(`Failed to prefetch: ${requestUrl}`)
            }
            const sectionsData = await response.json()
    
            keys.forEach((key, index) => {
              const sectionId = sectionIds[index]
              const data = sectionsData[sectionId]
              if (data !== undefined) {
                prefetchCache.set(key, data)
              }
              prefetchRequests.delete(key)
              ongoingFetches.delete(key)
    
              const callbacks = pendingRequests.get(key) || []
              pendingRequests.delete(key)
              callbacks.forEach(({ resolve, reject }) => {
                if (data !== undefined) {
                  resolve(data)
                } else {
                  reject(new Error(`No data for section ${sectionId}`))
                }
              })
            })
          }),
        )
      } catch (error) {
        console.error(error)
        const sectionKeys = Array.from(prefetchRequests)
        sectionKeys.forEach((key) => {
          prefetchRequests.delete(key)
          ongoingFetches.delete(key)
          const callbacks = pendingRequests.get(key) || []
          pendingRequests.delete(key)
          callbacks.forEach(({ reject }) => reject(error))
        })
      }
    }
    
    loadSection(sectionId, path = "", variantId, sellingPlanId) {
      const key = this.buildCacheKey(sectionId, path, variantId, sellingPlanId);
    
      if (prefetchCache.has(key)) {
        return Promise.resolve(prefetchCache.get(key));
      }
    
      return new Promise((resolve, reject) => {
        if (!pendingRequests.has(key)) {
          pendingRequests.set(key, []);
        }
        pendingRequests.get(key)?.push({ resolve, reject });
    
        if (!ongoingFetches.has(key) && !prefetchRequests.has(key)) {
          ongoingFetches.add(key);
          this.scheduleFetchSections();
        }
      });
    }
    
    prefetchSection(sectionId, path = "", variantId, sellingPlanId) {
      if (this.isDataSavingMode) {
        return;
      }
    
      const key = this.buildCacheKey(sectionId, path, variantId, sellingPlanId);
    
      if (pendingRequests.has(key) || ongoingFetches.has(key) || prefetchCache.has(key)) {
        return;
      }
    
      if (!prefetchRequests.has(key)) {
        prefetchRequests.add(key);
        this.schedulePrefetchSections();
      }
    }
    
    
    cancelPrefetchSection(sectionId, path = '', variantId) {
      const key = this.buildCacheKey(sectionId, path, variantId)
      prefetchRequests.delete(key)
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    updateUrl(productHandle, variantId, sellingPlanId) {
      let newUrl = `/products/${productHandle}`;
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);
    
      currentParams.forEach((value, key) => {
        if (key === "variant" || key === "selling_plan") {
          currentParams.delete(key);
        }
      });
    
      if (variantId) {
        currentParams.set("variant", variantId);
      }
    
      if (sellingPlanId) {
        currentParams.set("selling_plan", sellingPlanId);
      }
    
      const finalUrl = `${currentUrl.origin}${newUrl}?${currentParams.toString()}`;
    
      history.pushState({ url: finalUrl }, null, finalUrl);
    }

    updateSellingPlanInput(sellingPlanId) {
      if (this.combinedProductFormId) {
        const atcForm = document.getElementById(this.combinedProductFormId);

        if (atcForm) {
          // If we have a selling plan ID and an observer exists, disconnect it
          if (sellingPlanId && atcForm._observer) {
            atcForm._observer.disconnect();
            atcForm._observer = null;
          }
          
          // Remove any existing selling plan inputs
          const existingInputs = atcForm.querySelectorAll('input[name="selling_plan"]');
          existingInputs.forEach(input => {
            input.parentNode.removeChild(input);
          });
          
          // Add a new selling plan input if needed
          if (sellingPlanId) {
            const newInput = document.createElement("input");
            newInput.setAttribute("type", "hidden");
            newInput.setAttribute("name", "selling_plan");
            newInput.value = sellingPlanId;
            atcForm.appendChild(newInput);
          }
          
          // Set up observer only for one-time mode
          if (!atcForm._observer && !sellingPlanId) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                  mutation.addedNodes.forEach((node) => {
                    if (node.nodeName === 'INPUT' && node.getAttribute('name') === 'selling_plan') {
                      node.parentNode.removeChild(node);
                    }
                  });
                }
              });
            });
            
            observer.observe(atcForm, { childList: true, subtree: true });
            atcForm._observer = observer;
          }
        }
      }
    }

    addIconListShippingText() {
      let estimatedDate = '';
      document.querySelectorAll(this.ICON_LIST_ITEM_SELECTOR).forEach((item) => {
        function getMonthName(monthNumber) {
          const date = new Date();
          date.setMonth(monthNumber - 1);
          return date.toLocaleString('en-US', { month: 'long' });
        }

        const shippingDays = parseInt(item.dataset.thShippingEstimate);
        let date = new Date();
        date.setDate(date.getDate() + shippingDays);
        estimatedDate = `${getMonthName(date.getMonth() + 1)} ${date.getDate()}`;
        if (!estimatedDate) {return}
        item.innerHTML = `
        <span class="th-shipping-estimate">${estimatedDate}</span>
        `
      });
    }
    
    updatePriceDisplay(price) {
      const sectionId = this.getAttribute('data-section-id');
      if (sectionId) {
        const sectionElement = document.querySelector(`.${sectionId}`);
        if (sectionElement) {
          const priceDisplays = sectionElement.querySelectorAll('[data-atc-price]');
          if (priceDisplays.length) {
            priceDisplays.forEach(display => {
              display.textContent = price;
            });
          }
        } else {
          const priceDisplays = document.querySelectorAll('[data-atc-price]');
          if (priceDisplays.length) {
            priceDisplays.forEach(display => {
              display.textContent = price;
            });
          }
        }
      } else {
        const priceDisplays = document.querySelectorAll('[data-atc-price]');
        if (priceDisplays.length) {
          priceDisplays.forEach(display => {
            display.textContent = price;
          });
        }
      }
    }
    
    
  }

  customElements.define("td-combined-listing", TdCombinedListing);
}
